import React, { useState, useEffect, useRef } from 'react';
import AuthenticationForm from './AuthenticationForm';
import UpgradeToContact from './UpgradeToContact';
import AdvertiserDetails from './AdvertiserDetails';
import HiddenInputs from './HiddenInputs';
import Notification from './Notification';

function Form(props) {
  const [message, updateMessage] = useState(
    props.pageData.message || props.pageData.M_message,
  );
  const [showUpgrade, updateShowUpgrade] = useState(
    props.staticData.customer.id && props.pageData.upgrade_required,
  );
  const [isSendingMessage, updateIsSendingMessage] = useState(false);
  useEffect(() => {
    const storedMessage = JSON.parse(localStorage.getItem('contact-message'));
    if (storedMessage && storedMessage.date) {
      const oneMinuteAgo = Date.now() - 60000;
      if (storedMessage.date > oneMinuteAgo) {
        updateMessage(storedMessage.message);
      }
      localStorage.removeItem('contact-message');
    }
  }, []);

  const submitButton = useRef(null);
  const messageInput = useRef(null);
  const passwordInputRef = useRef();

  useEffect(() => {
    if (!props.staticData.customer.id) {
      localStorage.setItem(
        'contact-message',
        JSON.stringify({
          date: Date.now(),
          message: message,
        }),
      );
    }
  }, [message, props.staticData.customer.id]);
  function handleChange(event) {
    updateMessage(event.target.value);
  }

  function paymentCallback() {
    // throw up upgrade success message
    updateShowUpgrade(false);
    submitButton.current.click();
  }

  function handleSubmit(event) {
    if (passwordInputRef.current) {
      passwordInputRef.current.type = 'password';
    }
    if (!messageInput.current.checkValidity()) {
      updateIsSendingMessage(false);
    } else {
      updateIsSendingMessage(true);
    }
  }

  return (
    <div className="contact-form">
      <AdvertiserDetails
        profilePhotoUrl={
          props.pageData.advert.user.profile_photo_url ||
          `${props.staticData.site.static_files_server}/img/spareroom/v4/icons/profilepic_unisex.gif`
        }
        advert={props.pageData.advert}
        staticFilesServer={props.staticData.site.static_files_server}
        action={'Message'}
        localisations={props.pageLocalisations}
      />
      <Notification
        user={props.pageData.user}
        upgradeRequired={showUpgrade}
        contactType={'message'}
        localisations={props.pageLocalisations}
        siteName={props.staticData.page.site_name}
      />
      <form
        className="form"
        id="contact_form"
        action={props.pageData.contact_form_action}
        method="POST"
        name="contactAdvertiser"
        onSubmit={handleSubmit}
      >
        <HiddenInputs {...props.pageData} />
        <label className="contact-form__message-label" htmlFor="message">
          1. {props.pageLocalisations.enter_your_message}
        </label>
        <textarea
          className="contact-form__text-area"
          id="message"
          name="message"
          placeholder={`${props.pageLocalisations.hi} ${props.pageData.advert.user.first_name}...`}
          rows="4"
          wrap="soft"
          value={message}
          onChange={handleChange}
          ref={messageInput}
          required
        />
        {props.contactedThreadUrl ? (
          <div className="contact-form__contacted">
            <span className="contact-form__contacted-icon" aria-hidden="true">
              <i className="far fa-comment"></i>
            </span>
            {props.pageLocalisations.contacted}
            <a
              className="contact-form__contacted-link"
              href={props.contactedThreadUrl}
            >
              {props.pageLocalisations.go_to_conversation}
            </a>
          </div>
        ) : null}
        <div className="error-quality-check-message">
          <i className="far fa-exclamation-circle"></i>
          <span>
            Please provide more info about yourself (min 20 words), e.g. age,
            occupation and moving date. Or place a room wanted ad.
          </span>
        </div>
        {!props.staticData.customer.id ? (
          <>
            <AuthenticationForm
              advertType={props.pageData.advert.type}
              user={props.pageData.user}
              error={props.pageData.error}
              country={props.staticData.site.country}
              userKnown={props.staticData.session.user_known}
              csrf_token={props.pageData.csrf_token}
              subDir={props.staticData.site.sub_dir}
              loginFromUrl={props.staticData.site.loginReturnPath}
              facebookAppLocale={props.facebookAppLocale}
              locationId={props.pageData.search.location_id}
              affiliateId={props.staticData.affiliate.id}
              userLanguage={props.userLanguage}
              facebookLoginActive={props.facebookLoginActive}
              recaptcha_v3_site_key={
                props.staticData.site.recaptcha_v3_site_key
              }
              passwordInputRef={passwordInputRef}
              localisations={props.pageLocalisations}
              siteId={props.siteId}
            />
            {props.siteId != 21 ? (
              <p className="contact-form__recaptcha-terms">
                This site is protected by reCAPTCHA and the Google{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>{' '}
                and
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>{' '}
                apply.
              </p>
            ) : null}
          </>
        ) : !showUpgrade ? (
          <div className="contact-form__submit">
            <button
              className="button button--wide"
              ref={submitButton}
              onClick={handleSubmit}
            >
              <div className="button__content">
                <span className="button__icon">
                  <i className="far fa-envelope" />
                </span>
                <span className="button__text">
                  {isSendingMessage ? (
                    <span>
                      {props.pageLocalisations.sending_message}{' '}
                      <i
                        aria-hidden="true"
                        className="far fa-spinner fa-pulse"
                      ></i>
                    </span>
                  ) : (
                    props.pageLocalisations.send_message
                  )}
                </span>
              </div>
            </button>
          </div>
        ) : null}
      </form>
      {showUpgrade ? (
        <UpgradeToContact
          {...props}
          message={message}
          paymentCallback={paymentCallback}
        />
      ) : null}
    </div>
  );
}

export default Form;
